module.exports = __webpack_public_path__ + "img/liq2trans.c90a2050.png";